export const SEMESTER_SUMMARY_TABLE_NAME = "facility_usage_summary_semester_v3_partitioned"
export const HOURLY_SUMMARY_TABLE_NAME = "facility_usage_by_hour_enhanced_compacted_v2_partitioned"
